import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { startEditing } from 'bundles/apex/deals/show/store/overview/actions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import Card from 'bundles/apex/card';
import { getInvalidFieldsByTab } from 'bundles/apex/deals/show/config';

import './styles.scss';

export function OverviewHeader({ fields, invalidFields, startEditing }) {
  return (
    <Card className="overview-card d-flex justify-content-end" fullWidth>
      {getInvalidFieldsByTab(fields, invalidFields).overview.length > 0 &&
        <FontAwesomeIcon className="mr-3" icon={faExclamationCircle} size="2xl" />
      }

      <Button.Primary onClick={startEditing}>
        Edit
      </Button.Primary>
    </Card>
  );
}

OverviewHeader.propTypes = {
  fields: PropTypes.object,
  invalidFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  startEditing: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fields: state.fields,
  invalidFields: state.invalidFields,
});

const mapDispatchToProps = {
  startEditing,
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewHeader);
